// @ts-nocheck
import React, { useState } from 'react';
import ArrowToTop from '../ArrowToTop'
import '../../utils/colors.scss'
import ScrollToTopOnMount from '../ScrollToTopOnMount'
import URLS from '../../utils/urls'
import logo from '../../utils/czarymarry_logo.png'
import SeoContent from '../SeoContent'
import './styles.scss';
import { ReviewCard, reviews } from './ReviewCard';
import VideoEmbed from 'components/VideoEmbed';
import arrowToTop from '../Icons/arrowToTop.svg';
import Slider from 'react-slick';

const kursAudio = require('../../utils/kurs.mp3');

const APP_URL = process.env.REACT_APP_BASE_URL
const seo = {
    title: 'Kurs | Czary Marry',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    url: `${APP_URL}${URLS.COURSE}`,
    image: logo
}

const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: '0',
    autoplay: false,
    autoplaySpeed: 10000,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                centerMode: true,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                centerMode: true
            }
        },
    ]
};

const topics = [
    { topic: 'Wstęp.', lesson: 'Co daje kurs i jak z niego korzystać.' },
    { topic: 'Lekcja 01. Ogólna koncepcja ślubu i wesela.', lesson: 'Tworzenie wizji i założeń – punkt wyjścia do dalszych decyzji + autorskie narzędzie.' },
    { topic: 'Lekcja 02. Budżet ślubu i wesela.', lesson: 'Planowanie wydatków i zarządzanie budżetem + autorskie narzędzie.' },
    {
        topic: 'Lekcja 03. Miejsce wesela.', lesson: 'Określenie preferencji, research, analiza ofert + autorskie narzędzie, wizytacja miejsc, umowa.'
    },
    { topic: 'Lekcja 04. Harmonogram działań.', lesson: 'Jak go stworzyć + autorskie narzędzie.' },
    { topic: 'Lekcja 05. Noclegi.', lesson: 'Logistyka noclegów dla pary młodej i gości.' },
    { topic: 'Lekcja 06. Oprawa muzyczna wesela.', lesson: 'Określenie preferencji - zespół czy DJ, research, analiza ofert + autorskie narzędzie, spotkania z wykonawcami, umowa.' },
    { topic: 'Lekcja 07. Reportaż foto i video.', lesson: 'Określenie preferencji, research, analiza ofert + autorskie narzędzie, spotkania z wykonawcami, podpisanie umowy.' },
    { topic: 'Lekcja 08. Dekoracje.', lesson: 'Określenie preferencji, tworzenie wizji dekoracji, analiza ofert, spotkania z wykonawcami, podpisanie umowy + autorskie narzędzie.' },
    { topic: 'Lekcja 09. Oświetlenie.', lesson: 'Określenie preferencji, tworzenie wizji dekoracji, analiza ofert, spotkania z wykonawcami, podpisanie umowy.' },
    { topic: 'Lekcja 10. Formalności ślubne.', lesson: 'Formalności do ślubu kościelnego, cywilnego, humanistycznego/symbolicznego.' },
    { topic: 'Lekcja 11. Zaproszenia.', lesson: 'Kiedy, jak i kogo zapraszać, lista gości, tekst zaproszeń, współpraca z firmą papeteryjną + autorskie narzędzie.' },
    { topic: 'Lekcja 12. Makijaż i fryzjer.', lesson: 'Określenie preferencji, research, analiza ofert + autorskie narzędzie, makijaż i czesanie próbne, podpisanie umowy.' },
    { topic: 'Lekcja 13. Stroje pary młodej i orszaku weselnego + obrączki.', lesson: 'Poszukiwanie inspiracji strojów pary młodej, wizyta w salonie, stylizacja orszaku, dodatki, obrączki.' },
    { topic: 'Lekcja 14. Tort i słodkości.', lesson: 'Określenie preferencji, research, analiza ofert, degustacja, podpisanie umowy.' },
    { topic: 'Lekcja 15. Muzyka na ceremonię ślubną.', lesson: 'Określenie preferencji, research, analiza ofert, podpisanie umowy + autorskie narzędzie.' },
    { topic: 'Lekcja 16. Atrakcje weselne.', lesson: 'Atrakcje, które angażują, ale nie męczą, określenie preferencji, research, analiza ofert, podpisanie umowy.' },
    { topic: 'Lekcja 17. Transport.', lesson: 'Logistyka transportów dla pary młodej i gości.' },
    { topic: 'Lekcja 18. Dzieci na weselu.', lesson: 'Zapraszać z dziećmi czy bez? Jak uprzejmie zaprosić bez dzieci? Atrakcje dla dzieci na weselu.' },
    { topic: 'Lekcja 19. Papeteria przed weselem i dodatkowe elementy.', lesson: 'Table plan, tablica powitalna, menu, winietki, dodatkowe karty, zawieszki na wódkę, księga gości, pudełko na koperty.' },
    {
        topic: 'Lekcja 20. Menu i napoje.', lesson: 'Finger foods, obiad, ciepłe kolacje, zimny bufet, stacje jedzeniowe, alkohol, napoje.'
    },
    { topic: 'Lekcja 21. Podsumowanie wesela.', lesson: 'Scenariusz, ustalenia z miejscem weselnym, rozliczenia. 3 obszerne części i  autorskie narzędzia do tworzenia scenariusza, podsumowania z salą oraz rozliczenia.' },
    { topic: 'Lekcja 22. Odwołanie lub przeniesienie wesela.', lesson: 'Wskazówki i formalności do spełnienia.' },
    { topic: 'Zakończenie kursu.', lesson: 'Pożegnanie i kilka cennych rad od nas na koniec.' }
];

const CoursePage = () => {
    const [listVisible, setListVisible] = useState(false);

    const handleListVisibility = () => {
        setListVisible(!listVisible);
    }

    return (
        <div className="CoursePage">
            <ScrollToTopOnMount />
            <SeoContent {...seo} />
            <ArrowToTop />
            <div className="page-header">
                <h2 className="page-title smaller">Kurs online "Organizacja wesela krok po kroku"</h2>
            </div>
            <div className='CoursePage-content'>
                <div className='grid-container'>
                    <div className='grid-container_text'>
                        <ul className='list'>
                            <li className='pink-dot'>
                                <p>Zorganizujcie swoje wymarzone wesele – bez stresu, z planem i pewnością, że wszystko macie pod kontrolą.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>Z pomocą doświadczonych wedding plannerek z <span className='bold'>Czary Marry</span>.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>Dla par, które chcą planować samodzielnie, spokojnie i po swojemu.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>10h materiału wideo | 22 lekcje | 33 pliki do pobrania</p>
                            </li>
                        </ul>
                        <a className='call-to-action btn-mint' href="https://kurs.czarymarry.com" alt="Organizacja wesela krok po kroku" target="_blank" rel="noopener noreferrer">Kup kurs</a>
                        <a className='call-to-action btn-mint' href="https://kurs.czarymarry.com/product/darmowa-lekcja" alt="Pobierz darmową lekcję" target="_blank" rel="noopener noreferrer">Pobierz darmową lekcję</a>
                    </div>
                    <div className='grid-container_pic fixed-height-one'>
                        <VideoEmbed videoSrc="https://player.vimeo.com/video/1116498397" title="Kurs Organizacja wesela krok po kroku z Czary Marry" />
                    </div>
                </div>
                <div className='flex-container'>
                    <div className='first mr-3'>
                        <h2 className='header-main mb-4'>Czy to o Was?</h2>
                        <ul className='list'>
                            <li className='pink-dot'><p>Czujecie się przytłoczeni przygotowaniami i natłokiem informacji?</p></li>
                            <li className='pink-dot'><p>Przeszukaliście dziesiątki stron i forów, ale nadal nie wiecie, od czego zacząć?</p></li>
                            <li className='pink-dot'><p>Marzycie o ślubie dopracowanym w każdym szczególe, ale brakuje Wam jasnej struktury działania?</p></li>
                            <li className='pink-dot'><p>Nie wiecie, jak zapanować nad logistyką, noclegami i transportem?</p></li>
                            <li className='pink-dot'><p>Wciąż niepewnie czujecie się przy wyborze wykonawców?</p></li>
                        </ul></div>
                    <div className='second with-margin'>
                        <p>Kurs online <span className='bold'>Organizacja wesela krok po kroku z Czary Marry</span> pomoże Wam złapać oddech i uporządkować przygotowania w przemyślany sposób.</p>
                        <p>To pierwsze szkolenie online dostępne dla par, które chcą samodzielnie zaplanować swój ślub i wesele, ale nie chcą tracić czasu na błądzenie, szukanie, zgadywanie.</p>
                        <h3 className='pink mt-5 mb-4 text-center'>To jak prywatna konsultacja z wedding plannerkami, dostępna wtedy, kiedy jej potrzebujecie.</h3></div>
                </div>
                <h2 className='header-main text-center mb-4 pt-4'>Dla kogo jest ten kurs?</h2>
                <div className='flex-container'>
                    <div>
                        <h3 className='header-main_number dark'>01</h3>
                        <p>Dla par, które chcą samodzielnie zorganizować ślub i wesele – po swojemu, z duszą i bez chaosu.</p>
                    </div>
                    <div>
                        <h3 className='header-main_number mint'>02</h3>
                        <p>Dla tych, którzy cenią sobie kontrolę i chcą działać bez wedding plannera, ale z merytorycznym wsparciem.</p>
                    </div>
                    <div>
                        <h3 className='header-main_number pink'>03</h3>
                        <p>Dla zorganizowanych, kreatywnych i marzących o wyjątkowym dniu – zgodnym z własnym stylem, wartościami i budżetem.</p>
                    </div>
                </div>

                <h3 className='text-center pb-5'>Dajemy konkretne wsparcie, wiedzę i narzędzia, które naprawdę działają.</h3>

                <h2 className='header-main text-center mb-4 pt-4'>Co zyskacie dzięki kursowi?</h2>

                <div className='grid-container_reversed'>
                    <div className='grid-container_pic fixed-height-two'>
                        <VideoEmbed videoSrc="https://player.vimeo.com/video/1114955748?h=57babb3533" title="Kurs Organizacja wesela krok po kroku z Czary Marry 2" />
                    </div>
                    <div className='grid-container_text'>
                        <ul className='list'>
                            <li className='pink-dot'>
                                <p>Gotowy plan działania, który da Wam spójną wizję wesela – koniec z chaosem i wątpliwościami.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>Narzędzia do planowania budżetu, dzięki czemu wiecie, gdzie inwestować, a gdzie oszczędzać.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>Porady, jak zawierać bezpiecznie umowy – żadnych przykrych niespodzianek i ukrytych kosztów.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>Konkretną wiedzę – wszystko w jednym miejscu, bez błądzenia po internecie.</p>
                            </li>
                            <li className='pink-dot'>
                                <p>Luz w dniu ślubu – zero gonitwy, pełna obecność i radość.</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='buttons-wrapper'>
                    <a className='call-to-action btn-pink' href="https://kurs.czarymarry.com" alt="Organizacja wesela krok po kroku" target="_blank" rel="noopener noreferrer">Kup kurs</a>
                    <a className='call-to-action btn-pink' href="https://kurs.czarymarry.com/product/darmowa-lekcja" alt="Pobierz darmową lekcję" target="_blank" rel="noopener noreferrer">Pobierz darmową lekcję</a>
                </div>

                <h2 className='header-main text-center mb-4 pt-4'>Poznaj nas bliżej</h2>
                <div className="grid-container_third">
                    <div className="grid-container_text text-right">
                        <h4>
                            Cześć, tu Kasia i Ola z Czary Marry – jesteśmy duetem wedding plannerek z 10-letnim doświadczeniem.
                        </h4>
                        <p className="mt-5">Pomogłyśmy zorganizować setki ślubów, zawsze z troską, sercem i uważnością na potrzeby każdej pary. Wiemy, co działa naprawdę.</p>
                        <p className="mt-4">Zapraszamy do naszego małego świata pełnego porad oraz inspiracji ślubnych.</p>
                    </div>
                    <div className='grid-container_pic fixed-height'>
                        <VideoEmbed videoSrc="https://player.vimeo.com/video/1114959583" title="Kurs Organizacja wesela krok po kroku z Czary Marry 4" />
                    </div>
                </div>

                <h2 className='header-main text-center mb-4 pt-4'>Czary Marry to nie tylko agencja ślubna – to podejście.</h2>
                <p className='pt-4'>Partnerskie, wspierające, oparte na relacji. Właśnie takiego podejścia możecie się spodziewać w naszym kursie.</p>
                <figure className='audio-wrapper'>
                    <p className='bold'>Posłuchaj recencji:</p>
                    <audio controls src={kursAudio}></audio>
                </figure>
                <Slider {...settings}>
                    {reviews.map(({ author, text }) => (
                        <ReviewCard key={author} author={author}>
                            {text}
                        </ReviewCard>
                    ))}
                </Slider>

                <h2 className='header-main text-center mb-4 pt-5'>Co znajdziecie w kursie?</h2>
                <p>Ten kurs to nasze know-how – wszystko, co wiemy o organizacji ślubów – zamknięte w przystępnej formie, do której możecie wracać w dowolnym momencie. To nie tylko filmy instruktażowe – to gotowy proces, narzędzia, wskazówki i rozwiązania, z których korzystamy na co dzień w pracy z parami.</p>
                <p>Nie musicie mieć żadnego doświadczenia ani znać się na branży ślubnej. Przeprowadzimy Was przez każdy etap – od budowania wizji wesela, planowanie działań, budżetowanie przez wybór wykonawców, aż po podsumowanie ustaleń przed weselem.</p>
                <div className='buttons-wrapper'>
                    <a className='call-to-action btn-mint' href="https://kurs.czarymarry.com" alt="Organizacja wesela krok po kroku" target="_blank" rel="noopener noreferrer">
                        Kup kurs
                    </a>
                    <a className='call-to-action btn-mint' href="https://kurs.czarymarry.com/product/darmowa-lekcja" alt="Pobierz darmową lekcję" target="_blank" rel="noopener noreferrer">Pobierz darmową lekcję</a>
                </div>

                <div className='flex-container mt-5'>
                    <div className='first'>
                        <h3 className='pink mb-4'>Kurs możecie dopasować do siebie – niezależnie od tego, na jakim etapie przygotowań jesteście.</h3>
                        <p>Dostęp do kursu otrzymujecie zaraz po zakupie.</p>
                    </div>
                    <div className='second'>
                        <h3 className='mb-4'>W ramach kursu otrzymacie:</h3>
                        <ul className='list'>
                            <li className='pink-dot'>22 lekcje wideo.</li>
                            <li className='pink-dot'>Ponad 10 godzin materiałów.</li>
                            <li className='pink-dot'>33 praktyczne pliki do pobrania.</li>
                            <li className='pink-dot'>Dostęp do całości kursu przez 24 miesiące.</li>
                        </ul>
                    </div>
                </div>
                <h2 className='header-main text-center mb-4 mt-5'>Program kursu</h2>
                <p>Przeprowadzimy Was przez każdy etap planowania ślubu i wesela.</p>
                <ul className='list'>
                    <li className='pink-dot'>Tworzenie wizji ślubu i określenie budżetu.</li>
                    <li className='pink-dot'>Wybór miejsca, DJ-a, fotografa i innych usługodawców.</li>
                    <li className='pink-dot'>Planowanie dekoracji, papeterii, transportu i atrakcji.</li>
                    <li className='pink-dot'>Logistyka gości i noclegów.</li>
                    <li className='pink-dot'>Formalności, scenariusz dnia ślubu i rozliczenia.</li>
                </ul>

                <button onClick={handleListVisibility} className={`call-to-action btn-mint arrow-button ${listVisible && 'list-open'}`}>
                    Zobacz cały program kursu
                    <img src={arrowToTop} alt="arrow round" />
                </button>
                {listVisible && (
                    <div className='course-content-list'>
                        <h3 className='mb-4'>Spis treści:</h3>
                        {topics.map(({ topic, lesson }) => (
                            <div key={topic}>
                                <h4>{topic}</h4>
                                <p>{lesson}</p>
                            </div>
                        ))}
                    </div>
                )}
                <h2 className='header-main text-center mb-4 pt-5'>Zobaczcie, jak to działa</h2>
                <p>Pobierzcie bezpłatny, skrócony fragment lekcji o wyborze miejsca weselnego i sprawdźcie, jak może wyglądać Wasze planowanie z nami.</p>
                <a className='call-to-action btn-mint' href="https://kurs.czarymarry.com/product/darmowa-lekcja" alt="Pobierz darmową lekcję" target="_blank" rel="noopener noreferrer">
                    Pobierz darmową lekcję
                </a>

                <h2 className='header-main text-center mb-4 pt-5'>Gotowi zaplanować swoje wesele z poczuciem kontroli i spokoju?</h2>
                <p>Podczas kursu online zyskacie nie tylko wiedzę opartą na naszym ponad 10-letnim doświadczeniu, lecz przede wszystkim:</p>
                <ul className='list'>
                    <li className='pink-dot'>konkretne narzędzia i rekomendacje podane w przystępny sposób, bez błądzenia po forach, bez tracenia czasu na niesprawdzone rady</li>
                    <li className='pink-dot'>gotowe narzędzia do pobrania i dostęp do kursu</li>
                    <li className='pink-dot'>pełne wsparcie (naprawdę rozumiemy, z czym się mierzycie)</li>
                </ul>
                <p>Kupcie dostęp do kursu i przejdźcie przez cały proces krok po kroku.</p>
                <a className='call-to-action btn-pink' href="https://kurs.czarymarry.com" alt="Organizacja wesela krok po kroku" target="_blank" rel="noopener noreferrer">
                    KUP TERAZ
                </a>
            </div>
        </div>
    );
}

export default CoursePage;